import { Modal, Button } from 'mk-pc'
import { FC, useState } from 'react'

interface Props {
  visible: boolean
  title?: string
  message?: string
  sureButtonText?: string
  cancelButtonText?: string
  onConfirm?: () => void
  onClose?: () => void
}

/**
 * 删除确认框
 * @param props
 * @returns
 */
export const DeleteModal: FC<Props> = (props) => {
  const {
    visible,
    title = '删除提示',
    sureButtonText = '是，删除',
    cancelButtonText = '否，取消',
    message = '删除当前选择记录，是否继续？',
    onClose,
    onConfirm
  } = props
  const [loading, setLoading] = useState(false)

  /**
   * 关闭
   */
  const handleClose = () => {
    onClose && onClose()
  }

  /**
   * 确认
   * @returns
   */
  const handleConfirm = async () => {
    if (!onConfirm) return

    setLoading(true)

    try {
      await onConfirm()
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="back" onClick={handleClose}>
          {cancelButtonText}
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleConfirm}>
          {sureButtonText}
        </Button>
      ]}
    >
      <p>{message}</p>
    </Modal>
  )
}
